class CoursePage extends Component {
    constructor(el) {
        super(el);
        this.form = this.$find('form#CoursePage-form');
        this.container = this.$find('[data-video-container]');
        this.video = this.$find('[data-video]');
        this.playButton = this.$find('[data-play-button]');
        this.init();
    }

    init() {
        this.$findAll('.CoursePage-filters [data-filter-address]').forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                el.toggleAttribute('data-active');
                this.submitFilters();
            });
        });

        this.$findAll('.CoursePage-filters [data-filter-specialization]').forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                el.toggleAttribute('data-active');
                this.submitFilters();
            });
        });

        const sortButtons = this.$findAll('.CoursePage-order [data-sort]');
        sortButtons.forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                sortButtons.forEach(btn => btn.classList.remove('active'));
                el.classList.add('active');
                this.submitFilters();
            });
        });

        if (this.playButton) {
            this.playButton.addEventListener('click', () => this.playVideo());
            this.playButton.addEventListener('keydown', e => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.playVideo();
                }
            });
        }

        if (this.container) {
            this.container.addEventListener('keydown', e => {
                if ((e.key === "Enter" || e.key === " ") && !this.container.classList.contains('is-playing')) {
                    e.preventDefault();
                    this.playVideo();
                }
            });
        }
    }

    submitFilters() {
        if (!this.form) return;
        let formData = new FormData(this.form);

        this.$findAll('.CoursePage-filters [data-filter-address][data-active]').forEach(el => {
            formData.append('address[]', el.dataset.filterAddress);
        });

        this.$findAll('.CoursePage-filters [data-filter-specialization][data-active]').forEach(el => {
            formData.append('specialization[]', el.dataset.filterSpecialization);
        });

        const activeSort = this.$find('.CoursePage-order [data-sort].active');
        if (activeSort) {
            formData.append('sort', activeSort.dataset.sort);
        }

        for (let [key, value] of formData.entries()) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = value;
            this.form.appendChild(input);
        }
        this.form.submit();
    }

    playVideo() {
        if (this.container && this.video) {
            this.container.classList.add('is-playing');
            this.video.style.display = 'block';
            this.video.focus();
            if (this.video.play) this.video.play();
        }
    }
}
